import {
  UseQueryOptions,
  UseQueryResult,
  useQuery,
} from '@tanstack/react-query';
import { IFHError } from '../../../../apis/HttpBaseApiWrapper';
import { TPaginationParams } from '../../../../apis/__shared/shared.interfaces';
import { IRoutesResponse } from 'src/apis/administration/administration.interfaces';
import { useRoutesAndSchedulesService } from 'src/apis/administration/useRoutesAndSchedulesService';

type TQueryError = IFHError<{ message: string }>;
export const getRouteListKey = 'get-route-list';

export const useRouteListHook = (
  params: TPaginationParams,
  options?: UseQueryOptions<IRoutesResponse, TQueryError>
): UseQueryResult<IRoutesResponse, TQueryError> => {
  const { getRouteList } = useRoutesAndSchedulesService();

  return useQuery<IRoutesResponse, TQueryError>({
    queryKey: [getRouteListKey, params],
    queryFn: () => getRouteList(params),
    enabled: true,
    ...options,
  });
};
